module.exports = "/_next/static/images/first-home_apps-download-0ec258f7715ee02c7f0852286a9f04eb.svg";